<script>

	import { mapState, mapActions } from 'vuex'

	import './style.scss'

	export default {
		name: 'navigation',
		methods: {
			...mapActions([
				'logout',
			])
		},
		computed: mapState({
			'isLoggedIn': state => state.user.isLoggedIn,
		})
	}

</script>

<template>
	<div class='nav'>
		<div class='nav-container'>
			<div class='logo'>
				<router-link to='/'>
					<img class='full' src='/static/logo-head-blue.svg'>
					<img class='head' src='/static/logo-head-blue.svg'>
				</router-link>
			</div>
			<ul class='links'>
				<li>
					<button class='default-gray' @click='logout()' v-if='isLoggedIn'>
						Sign Out
					</button>
					<button class='blue' @click='$router.push("/login")' v-else-if='!isLoggedIn'>
						Sign In
					</button>
				</li>
			</ul>
		</div>
	</div>
</template>



// WEBPACK FOOTER //
// src/components/Navigation/Navigation.vue